var map = {
	"./Group 9964.svg": 700,
	"./Group 9998.svg": 491,
	"./ORDivider.svg": 492,
	"./account.svg": 701,
	"./account1.svg": 702,
	"./address.svg": 703,
	"./address_.svg": 704,
	"./advisory_entry_hero.svg": 493,
	"./advisory_female.svg": 705,
	"./advisory_male.svg": 706,
	"./amount_icon.svg": 494,
	"./arrow-left.svg": 495,
	"./arrow-right.svg": 496,
	"./attached.svg": 497,
	"./b1.svg": 707,
	"./b2.svg": 708,
	"./b3.svg": 709,
	"./b4.svg": 710,
	"./bacteria_fisdom.svg": 711,
	"./bank.svg": 712,
	"./bank_failed.svg": 713,
	"./bank_verification_success.svg": 714,
	"./banner_ext_pf.svg": 498,
	"./bed_corona_fisdom.svg": 715,
	"./bg_crousal.svg": 716,
	"./buyback_transparent.svg": 717,
	"./calculatemi.svg": 718,
	"./calender-rs.svg": 499,
	"./call_back_confirm.svg": 719,
	"./cas_not_received.svg": 500,
	"./cash-payment.svg": 501,
	"./certificate-rs.svg": 720,
	"./chat_bubble.svg": 502,
	"./congrats.svg": 721,
	"./congratulations.svg": 722,
	"./corpus_switch.svg": 503,
	"./crd_gold_info.svg": 504,
	"./cross.svg": 723,
	"./daily_exprenses_fisdom.svg": 724,
	"./deliver.svg": 725,
	"./desktop_partner_landing_pnb.svg": 505,
	"./document.svg": 726,
	"./document_.svg": 727,
	"./down_arrow.svg": 506,
	"./down_arrow_fisdom.svg": 144,
	"./download.svg": 507,
	"./eligibility.svg": 728,
	"./entry_insurance_advisory.svg": 508,
	"./equity_derivatives_transparent.svg": 729,
	"./error_illustration.svg": 730,
	"./exclamation.svg": 731,
	"./expense.svg": 509,
	"./failed_order_delivery.svg": 732,
	"./fd_partner_login.svg": 378,
	"./fisdom_hni_advisory_logo.svg": 379,
	"./fisdom_hni_advisory_logo_white.svg": 380,
	"./fisdom_hni_logo_dark.svg": 733,
	"./fisdom_hni_logo_gold.svg": 126,
	"./fisdom_icon.svg": 734,
	"./fisdom_icon_gold.svg": 222,
	"./fisdom_icon_white.svg": 735,
	"./fisdom_logo.svg": 366,
	"./fisdom_logo_coloured.svg": 510,
	"./fisdom_logo_white.svg": 736,
	"./fisdom_white_logo.svg": 381,
	"./fpo_transparent.svg": 737,
	"./fyntune_landing_page_hero.svg": 511,
	"./get_insured_carousel_1.svg": 738,
	"./get_insured_carousel_2.svg": 739,
	"./get_insured_carousel_3.svg": 740,
	"./gold.svg": 741,
	"./group.svg": 512,
	"./hand.svg": 513,
	"./home_insurance_icon.svg": 742,
	"./hourglass.svg": 514,
	"./ic-account.svg": 515,
	"./ic-added-pans.svg": 367,
	"./ic-clear-filter.svg": 516,
	"./ic-diversification.svg": 743,
	"./ic-dropdown.svg": 517,
	"./ic-email-sync.svg": 518,
	"./ic-emails.svg": 519,
	"./ic-filter.svg": 520,
	"./ic-fund-selection.svg": 744,
	"./ic-info-primary.svg": 369,
	"./ic-info.svg": 334,
	"./ic-investment-strategy.svg": 745,
	"./ic-mob-add-email.svg": 746,
	"./ic-mob-add-mail.svg": 747,
	"./ic-mob-add-pic.svg": 748,
	"./ic-mob-dropdown.svg": 521,
	"./ic-mob-emails.svg": 522,
	"./ic-mob-filter.svg": 523,
	"./ic-mob-logout.svg": 524,
	"./ic-mob-success.svg": 525,
	"./ic-mob-trust.svg": 749,
	"./ic-mobile-verification.svg": 526,
	"./ic-nav-analysis-active.svg": 750,
	"./ic-nav-analysis-inactive.svg": 751,
	"./ic-nav-holdings-active.svg": 752,
	"./ic-nav-holdings-inactive.svg": 753,
	"./ic-nav-overview-active.svg": 754,
	"./ic-nav-overview-inactive.svg": 755,
	"./ic-nav-taxation-active.svg": 756,
	"./ic-nav-taxation-inactive.svg": 757,
	"./ic-portfolio-composition.svg": 758,
	"./ic-portfolio-liquidity.svg": 759,
	"./ic-profile-avatar.svg": 527,
	"./ic-right-chevron.svg": 760,
	"./ic-secure.svg": 761,
	"./ic-tax-efficiency.svg": 762,
	"./ic_amfi_white.svg": 382,
	"./ic_arrow_left.svg": 335,
	"./ic_auth_bank.svg": 763,
	"./ic_bank_added.svg": 764,
	"./ic_bank_not_added.svg": 765,
	"./ic_bank_partial_added.svg": 766,
	"./ic_benefit_gold.svg": 528,
	"./ic_bse_white.svg": 383,
	"./ic_btm_mail_check.svg": 767,
	"./ic_buy_gold.svg": 768,
	"./ic_close.svg": 384,
	"./ic_customer_portal.svg": 769,
	"./ic_date_payment.svg": 529,
	"./ic_delivery.svg": 770,
	"./ic_diverse_pf.svg": 771,
	"./ic_document_amount.svg": 772,
	"./ic_document_card.svg": 773,
	"./ic_document_cash.svg": 774,
	"./ic_document_cloud.svg": 775,
	"./ic_document_copy.svg": 530,
	"./ic_document_location.svg": 776,
	"./ic_document_mobile.svg": 777,
	"./ic_document_note.svg": 778,
	"./ic_encryption.svg": 779,
	"./ic_esign_done_fisdom.svg": 273,
	"./ic_esign_otp_fisdom.svg": 274,
	"./ic_get_money.svg": 780,
	"./ic_gold_added.svg": 781,
	"./ic_gold_provider.svg": 782,
	"./ic_help.svg": 783,
	"./ic_how_to_claim.svg": 531,
	"./ic_how_to_claim2.svg": 532,
	"./ic_hs_cover_amount.svg": 533,
	"./ic_hs_cover_periods.svg": 534,
	"./ic_hs_insured.svg": 535,
	"./ic_hs_medical_checkup.svg": 784,
	"./ic_hs_pay_freq.svg": 536,
	"./ic_hs_policy.svg": 537,
	"./ic_input.svg": 785,
	"./ic_input_65.svg": 786,
	"./ic_intelligent_pf.svg": 787,
	"./ic_loan_schedule.svg": 788,
	"./ic_locker.svg": 538,
	"./ic_mail.svg": 539,
	"./ic_make_payment.svg": 789,
	"./ic_medical_checkup.svg": 540,
	"./ic_medical_checkup2.svg": 541,
	"./ic_paper_plane.svg": 385,
	"./ic_personal_accident.svg": 790,
	"./ic_policy_period.svg": 542,
	"./ic_purity.svg": 543,
	"./ic_read.svg": 544,
	"./ic_risk_analyse.svg": 791,
	"./ic_sebi.svg": 792,
	"./ic_sebi_white.svg": 386,
	"./ic_sec_basic_materials.svg": 387,
	"./ic_sec_chemicals.svg": 793,
	"./ic_sec_communication.svg": 388,
	"./ic_sec_cons_durable.svg": 794,
	"./ic_sec_consumer_cyclical.svg": 389,
	"./ic_sec_consumer_defensive.svg": 390,
	"./ic_sec_energy.svg": 391,
	"./ic_sec_finance.svg": 392,
	"./ic_sec_healthcare.svg": 393,
	"./ic_sec_industrials.svg": 394,
	"./ic_sec_others.svg": 395,
	"./ic_sec_real_estate.svg": 396,
	"./ic_sec_technology.svg": 397,
	"./ic_sec_utility.svg": 398,
	"./ic_secure_vault.svg": 545,
	"./ic_sell_gold.svg": 795,
	"./ic_sip_mandate_attention.svg": 796,
	"./ic_term_insurance.svg": 797,
	"./ic_to_sell_gold.svg": 546,
	"./ic_verify_otp_fisdom.svg": 275,
	"./ic_wallet.svg": 798,
	"./ic_whats_covered.svg": 547,
	"./ic_whats_not_covered.svg": 548,
	"./ic_whatsapp_failed.svg": 549,
	"./ic_whatsapp_small.svg": 799,
	"./ic_why_hs.svg": 800,
	"./ic_why_hs2.svg": 801,
	"./ic_why_hs3.svg": 802,
	"./ic_why_hs4.svg": 803,
	"./ic_why_hs_gmc_1.svg": 804,
	"./ic_why_hs_gmc_2.svg": 805,
	"./ic_why_hs_gmc_3.svg": 806,
	"./ic_why_hs_loan.svg": 807,
	"./ic_why_loan.svg": 808,
	"./ic_why_loan1.svg": 809,
	"./ic_why_loan2.svg": 810,
	"./ic_why_loan3.svg": 811,
	"./ic_why_loan_3.svg": 812,
	"./ic_why_loan_4.svg": 813,
	"./icn_Issue_loan.svg": 814,
	"./icn_ROI.svg": 815,
	"./icn_application_created.svg": 550,
	"./icn_assistance.svg": 551,
	"./icn_awaiting_period_fisdom.svg": 816,
	"./icn_b1_m.svg": 817,
	"./icn_b2_m.svg": 818,
	"./icn_b3_fisdom.svg": 819,
	"./icn_b3_m.svg": 820,
	"./icn_b4_m.svg": 821,
	"./icn_b_1.svg": 822,
	"./icn_b_2.svg": 823,
	"./icn_b_3.svg": 824,
	"./icn_bt_1.svg": 825,
	"./icn_bt_2.svg": 826,
	"./icn_bt_3.svg": 827,
	"./icn_ca.svg": 552,
	"./icn_contact.svg": 553,
	"./icn_couple.svg": 828,
	"./icn_crousal_card_1.svg": 829,
	"./icn_diseases_insurance.svg": 830,
	"./icn_end_date.svg": 554,
	"./icn_expert_match.svg": 831,
	"./icn_file_itr.svg": 832,
	"./icn_free.svg": 555,
	"./icn_health_insurance.svg": 833,
	"./icn_hero.svg": 834,
	"./icn_hs_assistance.svg": 835,
	"./icn_hs_no_document.svg": 836,
	"./icn_hs_payment.svg": 837,
	"./icn_identity.svg": 556,
	"./icn_issue_date.svg": 557,
	"./icn_journey_start.svg": 838,
	"./icn_kids.svg": 839,
	"./icn_life insurance.svg": 840,
	"./icn_loan_amnt.svg": 841,
	"./icn_lourney_end.svg": 842,
	"./icn_mail_id.svg": 558,
	"./icn_motor_insurance.svg": 843,
	"./icn_msg_sent.svg": 559,
	"./icn_notification.svg": 844,
	"./icn_ongoingcovid_fisdom.svg": 845,
	"./icn_online_support.svg": 846,
	"./icn_other_insurance.svg": 847,
	"./icn_parents.svg": 848,
	"./icn_payment_frequency.svg": 560,
	"./icn_phn_no.svg": 561,
	"./icn_plan_type.svg": 562,
	"./icn_policy_found_f.svg": 563,
	"./icn_quarantine_fisdom.svg": 849,
	"./icn_review_1.svg": 564,
	"./icn_review_2.svg": 565,
	"./icn_review_3.svg": 566,
	"./icn_review_edit.svg": 850,
	"./icn_review_file.svg": 851,
	"./icn_salaried.svg": 852,
	"./icn_satisfied_clients.svg": 853,
	"./icn_self_employed.svg": 854,
	"./icn_self_itr.svg": 567,
	"./icn_service_ratings.svg": 855,
	"./icn_start_date_1.svg": 568,
	"./icn_tax_filing.svg": 856,
	"./icn_tax_made_simple.svg": 857,
	"./icn_time.svg": 569,
	"./icn_travel_covid_fisdom.svg": 858,
	"./icn_upload_form_16.svg": 859,
	"./icn_zero_paper.svg": 570,
	"./icon_color.svg": 860,
	"./identity.svg": 861,
	"./identity_.svg": 862,
	"./idfc_card.svg": 863,
	"./ils_alternate_assets.svg": 571,
	"./ils_covid_failed.svg": 864,
	"./ils_covid_failed_copy_2.svg": 865,
	"./ils_covid_pending.svg": 866,
	"./ils_covid_success.svg": 867,
	"./ils_digilocker_failed.svg": 868,
	"./ils_digilocker_success.svg": 869,
	"./ils_error.svg": 399,
	"./ils_esign_failed.svg": 870,
	"./ils_esign_kyc.svg": 572,
	"./ils_esign_success.svg": 871,
	"./ils_gold_purchase_failed.svg": 872,
	"./ils_gold_purchase_pending.svg": 873,
	"./ils_gold_purchase_success.svg": 874,
	"./ils_gold_sell_failed.svg": 875,
	"./ils_gold_sell_success.svg": 876,
	"./ils_hassle_free.svg": 573,
	"./ils_loan_approve.svg": 877,
	"./ils_loan_email.svg": 878,
	"./ils_loan_failed.svg": 879,
	"./ils_loan_intro_card.svg": 880,
	"./ils_loan_status.svg": 881,
	"./ils_no_data.svg": 400,
	"./ils_timeout.svg": 574,
	"./ils_wip.svg": 882,
	"./ils_wip_mob.svg": 883,
	"./inactive-policy-background.svg": 575,
	"./inc_infected_fisdom.svg": 884,
	"./inc_outside_india_fisdom.svg": 885,
	"./income_.svg": 886,
	"./info_icon.svg": 576,
	"./insurance_landing_hero.svg": 887,
	"./invest.svg": 577,
	"./ipo_transparent.svg": 888,
	"./irdanewlogo1.svg": 889,
	"./its_help.svg": 401,
	"./its_help_mob.svg": 890,
	"./landing_call_back_button.svg": 578,
	"./landing_customer_carousel_1.svg": 891,
	"./landing_customer_carousel_2.svg": 892,
	"./landing_customer_carousel_3.svg": 893,
	"./landing_step_verified.svg": 402,
	"./loan.svg": 579,
	"./loan_hand.svg": 894,
	"./loan_icon.svg": 895,
	"./loan_success.svg": 896,
	"./lock_key.svg": 897,
	"./mandate_pending_icon.svg": 580,
	"./meter-aggressive.svg": 581,
	"./meter-conservative.svg": 582,
	"./meter-moderate.svg": 583,
	"./meter-moderately-aggressive.svg": 584,
	"./meter-moderately-conservative.svg": 585,
	"./mobile_credit_card.svg": 898,
	"./money_pig.svg": 899,
	"./mutual_fund.svg": 900,
	"./ncd_transparent.svg": 901,
	"./next_arrow.svg": 586,
	"./no-filter-results.svg": 902,
	"./not_eligible.svg": 903,
	"./nps.svg": 904,
	"./order_id.svg": 587,
	"./pan.svg": 905,
	"./payment_transaction.svg": 906,
	"./pending_order_delivery.svg": 907,
	"./people_sitting_fisdom.svg": 908,
	"./personal.svg": 588,
	"./pointer_icon.svg": 403,
	"./policy_icon.svg": 589,
	"./rebalance_date.svg": 590,
	"./rebalance_pointer.svg": 591,
	"./rebalance_report.svg": 592,
	"./register_icn.svg": 909,
	"./report_icon.svg": 404,
	"./residence.svg": 910,
	"./rp_intro_banner.svg": 593,
	"./salary.svg": 911,
	"./sbi.svg": 912,
	"./search.svg": 913,
	"./secure.svg": 594,
	"./server_error_page.svg": 595,
	"./sgb_transparent.svg": 914,
	"./shield.svg": 596,
	"./singlebed_fisdom.svg": 915,
	"./sip_corpus_switch.svg": 597,
	"./sip_date_icon.svg": 598,
	"./sip_switch.svg": 599,
	"./status_sip_icon.svg": 600,
	"./successful_switch.svg": 601,
	"./sucess_order_delivery.svg": 916,
	"./team_tag.svg": 917,
	"./term_insurance.svg": 918,
	"./track_ext_pf.svg": 919,
	"./track_order.svg": 602,
	"./unsubscribe_product_logo.svg": 603,
	"./update_mobile.svg": 604,
	"./us_continue.svg": 920,
	"./us_done.svg": 921,
	"./us_mail.svg": 605,
	"./whatsapp.svg": 606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 956;